// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateAuthorizeSetting_createButton__bKk_a","buttonsContainer":"CreateAuthorizeSetting_buttonsContainer__CJ3mP"};